import { HttpService } from '../../../services/http.service';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { CommissionStatementsQueryParams } from 'src/app/shared/interfaces/commission-statement.query-params copy';
import { BankTransactionsResponseInterface } from 'src/app/shared/interfaces/bank-transactions-response.interface';
import { TradeTransactionsResponseInterface } from 'src/app/shared/interfaces/trade-transactions-response.interface';
import { InvestmentsQueryParams } from 'src/app/shared/interfaces/investments-query-params';
import { Summary } from 'src/app/shared/interfaces/bank-response.interface';
import { environment } from 'src/environments/environment';
import { InvestmentsResponseInterface } from 'src/app/shared/interfaces/investments-response.interface';
import { InvestmentsDistinctFilterValuesInterface } from 'src/app/investments/common/interfaces/investments-distinct-filter-values.interface';
import { FinancialStatementResponse } from '../../interfaces/financial-statement-response.interface';

@Injectable({
  providedIn: 'root',
})
export class InvestorStatementHttpService extends HttpService {
  getcommissionStatementData(params: Partial<CommissionStatementsQueryParams>): Observable<TradeTransactionsResponseInterface> {
    return this.http.get<BankTransactionsResponseInterface>(`${this.intermediaryBaseUrl}banks?`, {
      params: this.queryCleaner(params),
    });
  }

  getInvestmentsData(params: Partial<InvestmentsQueryParams>): Observable<InvestmentsResponseInterface> {
    const baseUrl = environment.intermediaryUrl + 'investments';
    return this.http.get<InvestmentsResponseInterface>(baseUrl, {
      params: this.queryCleaner(params),
    });
  }

  getInvestmentsSummary(params: Partial<InvestmentsQueryParams>): Observable<Summary> {
    return this.http.get<Summary>(`${this.intermediaryBaseUrl}investments/summary`, {
      params: this.queryCleaner(params),
    });
  }

  getFilterData(): Observable<InvestmentsDistinctFilterValuesInterface> {
    return this.http.get<InvestmentsDistinctFilterValuesInterface>(`${this.intermediaryBaseUrl}investments/distinct-filter-values`);
  }

  getFinancialStatementData(params: Partial<InvestmentsQueryParams>): Observable<InvestmentsResponseInterface> {
    return this.http.get<InvestmentsResponseInterface>(`${this.intermediaryBaseUrl}financial-statements`, {
      params: this.queryCleaner(params),
    });
  }
 
  getFinancialStatementSummary(params: Partial<InvestmentsQueryParams>): Observable<any> {
    return this.http.get<any>(`${this.intermediaryBaseUrl}financial-statements/summary`, {
      params: this.queryCleaner(params),
    });
  }
  
  getFinancialStatementLatestList(): Observable<FinancialStatementResponse> {
    return this.http.get<FinancialStatementResponse>(`${this.intermediaryBaseUrl}financial-statements/latest-list`);
  }

}
